module.exports = __webpack_public_path__ + "img/adhka-yx1zn.007.7a8b3df8.jpeg";